import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCustomerSchedulePackageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getCustomerSchedule = createAsyncThunk('getCustomerSchedule', async (payload) => {
  return await getCustomerSchedulePackageApi(payload);
});

const getCustomerScheduleSlice = createSlice({
  name: 'getCustomerSchedule', // Unique Name
  initialState,
  reducers: {
    getCustomerScheduleReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerSchedule.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getCustomerSchedule.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getCustomerSchedule.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getCustomerScheduleReset } = getCustomerScheduleSlice.actions;

export default getCustomerScheduleSlice.reducer;
